<template>
  <div style="display:flex">
    <!-- <span class="pic-font"
      >备注:支持格式：jpg、png、jpeg，单个图片不能超过1M</span
    > -->
    <el-upload
      :action="baseImgUrl"
      :headers="token"
      :with-credentials="true"
      list-type="picture-card"
      :limit="limit"
      :multiple="true"
      :file-list="fileList"
      :on-change="handleChange"
      :class="{ disabledCard: uploadDisabled}"
      :before-upload="uploadBefore"
      :on-remove="handleRemove"
      :on-preview="handlePictureCardPreview"
      :on-success="uploadSuccess"
      :on-error="uploadError"
      :accept="updateData.fileType"
    >
        <i class="el-icon-plus"></i>
        <div slot="tip" v-if="updateData.updateMsg.length>0 && tipPosition==='down'" class="el-upload__tip" style="margin-left:0rem">{{updateData.updateMsg}}</div>
      <!-- <div style="display:flex">
        <el-button size="small" type="primary">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">{{updateData.updateMsg}}</div>
      </div> -->
    </el-upload>
    <div class="el-upload__tip" v-if="updateData.updateMsg.length>0 && tipPosition==='left'" slot="tip">{{updateData.updateMsg}}</div>
    <!-- <span class="pic-font"
      >备注:支持格式：jpg、png、jpeg，单个图片不能超过1M</span
    > -->
    <el-dialog :visible.sync="dialogVisible" title="预览">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'EXUploadImg',
  props: {
    updateData: {
      type: Object
    },
    limit: {
      type: Number,
      default: 5,
    },
    tipPosition:{
      type: String,
      default: 'down'
    },
    // multiple:{
    //   type: Boolean,
    //   default: false
    // },
    itemValue:{
      type: String,
      default: "",
    }
  },
  data() {
    return {
      dialogVisible: false,
      dialogImageUrl: "",
      baseImgUrl: $config.uploadUrl,
      token: {},
      fileList: [],
      uploadDisabled: false,
      isRemove: false,
      fileType: '.jpg,.png,.jpeg,.mp4',
      lookFile: $config.rootUrl,
      notifyPromise: Promise.resolve()
    };
  },
  methods: {
     // add by weili图片回显
     initImageList(attachments){
      if (attachments && attachments.length >= 1) {
        var tempArr = attachments.map((item, idx) => {
            var  data = {
              name: item.attachName,  //预览需要的属性
              url: this.lookFile + item.filePath,//预览需要的属性
              attachType: item.fileType,
              filePath: item.filePath,
              httpUrl: item.httpUrl,
              attachSize:item.attachSize    
            }
            return data
        })
        this.fileList = JSON.parse(JSON.stringify(tempArr))
      }
      this.handleChange("",this.fileList)
    },
    // 图片个数变化控制上传按钮的显示和隐藏
    handleChange(file,fileList) {
      if (fileList.length >= this.limit) {
        this.uploadDisabled = true;
      }else{
        this.uploadDisabled = false;
      }
    },
    // 对图片大小做限制
    uploadBefore(file) {
      console.log(file.type)
      const isIMAGES =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "video/mp4";
      // const isLtM = file.size / 1024 < 10240;
      const isLtM = this.updateData.updateSize && file.size < this.updateData.updateSize
      if (!isLtM) {
        // this.$message({
        //   message: "上传文件大小不能超过 1M!",
        //   type: "error",
        // });
        this.warningNotify(this.updateData.updateSizeMsg);
      }
      if (!isIMAGES) {
        // this.$message({
        //   message: "上传文件必须是图片格式!",
        //   type: "error",
        // });
        this.warningNotify(this.updateData.updateTypeMsg);
      }
      this.isRemove = isIMAGES && isLtM;
      return isIMAGES && isLtM;
    },
    //  照片移除方法
    handleRemove(file, fileList) {
      var attachment = []
      if (fileList) {
        if (fileList instanceof Array) {
          attachment = fileList.map((item, idx) => {
            if (item.status === 'success') {
              var data = {}
              if (item.response) {
                data = {
                  attachName: item.name,
                  attachType: item.response.body.fileResponseData.fileType,
                  filePath: item.response.body.fileResponseData.filePath,
                  httpUrl: item.response.body.fileResponseData.httpUrl,
                  attachSize:item.response.body.fileResponseData.fileSize,
                }
              } else {
                data = {
                  attachName: item.name,
                  attachType: item.fileType,
                  filePath: item.filePath,
                  httpUrl: item.httpUrl,
                  attachSize:item.attachSize    
                }
              }
              
              if (item.response) {
                // this.$message.success(item.response.msg)
                // this.successNotify(item.response.msg);
              }
              return data
            }
          })
        } else {
          if (fileList.response) {
            // this.$message.error(fileList.response.msg)
            this.warningNotify(fileList.response.msg);
          }
        }
      }
      var deleteFile = {}
      if (file) {
        var item = file
         if (item.status === 'success') {
            if (item.response) {
              deleteFile = {
                attachName: item.name,
                attachType: item.response.body.fileResponseData.fileType,
                filePath: item.response.body.fileResponseData.filePath,
                httpUrl: item.response.body.fileResponseData.httpUrl,
                attachSize:item.response.body.fileResponseData.fileSize,
              }
            } else {
              deleteFile = {
                attachName: item.name,
                attachType: item.fileType,
                filePath: item.filePath,
                httpUrl: item.httpUrl,
                attachSize:item.attachSize   
              }
            }
          }
      }
      this.$emit('remove-image', attachment,deleteFile,this.itemValue)
      this.handleChange("",attachment)
    },
    // 预览图片
    handlePictureCardPreview(file) {
      if (file) {
        this.dialogImageUrl = file.url ? file.url: file.response.body.fileResponseData.filePath
        this.dialogVisible = true;
      }
    },
    // 上传图片成功  // add by weili
    uploadSuccess(res, file, fileList) {
      if (!res.success) {
        this.setAttachmentList(fileList.pop())
      }
      this.setAttachmentList(fileList)
    },
    // 上传图片出错
    uploadError(err) {
      // this.$message.error("上传出错" + err);
      this.warningNotify(`上传出错!${err}`);
    },
     // 附件列表赋值 
     setAttachmentList(fileList){
      if (fileList) {
        if (fileList instanceof Array) {
          const attachment = fileList.map((item, idx) => {
            if (item.status === 'success') {
              var data = {}
              if (item.response) {
                data = {
                  attachName: item.name,
                  attachType: item.response.body.fileResponseData.fileType,
                  filePath: item.response.body.fileResponseData.filePath,
                  httpUrl: item.response.body.fileResponseData.httpUrl,
                  attachSize:item.response.body.fileResponseData.fileSize,
                }
              } else {
                data = {
                  attachName: item.name,
                  attachType: item.fileType,
                  filePath: item.filePath,
                  httpUrl: item.httpUrl,
                  attachSize:item.attachSize    
                }
              }
              if (item.response) {
                // this.$message.success(item.response.msg)
                // this.successNotify(item.response.msg);
              }
              return data
            }
          })
          this.$emit('update-image', attachment,this.itemValue)
        } else {
          if (fileList.response) {
            // this.$message.error(fileList.response.msg)
            this.warningNotify(fileList.response.msg);
          }
          this.fileList = []
        }
      }
     },
     warningNotify(msg) {
        let _this = this;
        this.notifyPromise = this.notifyPromise.then(_this.$nextTick).then(() => {
            _this.$notify({
                type: 'warning',
                title: '警告',
                message: msg,
                duration: 2000
            });
        });
    },
    successNotify(msg) {
        let _this = this;
        this.notifyPromise = this.notifyPromise.then(_this.$nextTick).then(() => {
            _this.$notify({
                type: 'success',
                message: msg,
                duration: 2000
            });
        });
    }
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.disabledCard{
  position: relative;
}
//控制隐藏上传按钮
/deep/.disabledCard .el-upload--picture-card{
  display: none;
}
.pic-font{
  position: absolute;
  left: 1.7rem;
}
// el-upload-list
.el-upload-list--picture {
  width: 10%;
}
/deep/ .el-upload--picture {
  width: 1.5rem;
  height: 1.5rem;
  border: 1px dashed #d9d9d9;
  line-height: 1.5rem;
}
.el-upload__tip {
  margin-left: 0.2rem;
}
/deep/ .el-dialog__header{
  padding:0.1rem 0.2rem 0 0.2rem;
}
</style>


// WEBPACK FOOTER //
// src/components/EXUpload/uploadImg.vue